module.exports = __webpack_public_path__ + "img/login-right.31c65b27.svg";